import { SoftwareSlide } from './software-slide.model';

export class Software {
  title: string = '';
  slides: Array<SoftwareSlide> = [];
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/products/shared/models/software.model.ts